export default __webpack_public_path__ + "static/media/passwordNavIcon.5366e0f7.svg";